import React, { useEffect, useState } from 'react';
import { onSocketStatus } from '../services/socket';

const STYLE = {
  connected:    { color: 'var(--profit, #2dce89)',        label: 'Live',      title: 'Real-time connection active' },
  reconnecting: { color: '#e0a800',                       label: 'Reconnecting', title: 'Live connection lost — retrying. Data may be stale.' },
  disconnected: { color: 'var(--text-tertiary, #6c757d)', label: 'Offline',   title: 'No live connection' },
};

// Small navbar indicator for the Socket.IO connection state, so a silently
// stale dashboard is visible instead of masquerading as live data.
export default function LiveDot() {
  const [status, setStatus] = useState('disconnected');

  useEffect(() => onSocketStatus(setStatus), []);

  const s = STYLE[status] || STYLE.disconnected;
  return (
    <span
      title={s.title}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontSize: 11, color: 'var(--text-tertiary)',
        textTransform: 'uppercase', letterSpacing: '0.06em',
        marginRight: 10, whiteSpace: 'nowrap',
      }}
    >
      <span style={{
        width: 8, height: 8, borderRadius: '50%',
        background: s.color,
        boxShadow: status === 'connected' ? `0 0 6px ${s.color}` : 'none',
      }} />
      <span className="d-none d-md-inline">{s.label}</span>
    </span>
  );
}
